import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import ContactPersonApi from '@infrastructure/contact-person-api';
export const addContactPersonAsync = createAsyncThunk('ContactPerson/add', async (contactPerson, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ContactPersonApi.addContactPersons(contactPerson);
        dispatch(addSuccessNotification(translate('contactPerson.contactPersonCreatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getContactPersonByIdAsync = createAsyncThunk('ContactPerson/getById', async (Id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ContactPersonApi.getContactPersonById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateContactPersonAsync = createAsyncThunk('ContactPerson/update', async (contactPerson, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ContactPersonApi.updateContactPersons(contactPerson);
        dispatch(addSuccessNotification(translate('contactPerson.contactPersonUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
